// extracted by mini-css-extract-plugin
module.exports = {"modal__wrap":"Modal_modal__wrap__2aG7Q","visible":"Modal_visible__1eez6","modal":"Modal_modal__2g0Wb","close__btn":"Modal_close__btn__crbZi"};